export default __webpack_public_path__ + "static/media/SILKY.1c8f6cc8.jpg";